import { useCallback, useEffect, useState } from 'react'
import { useFormDialog } from '@hooks/useListForms'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'

type Props = {
  queryParam?: string
}

type HookType = (props: Props) => {
  entityId: string | null
  detailsTab: number
  setDetailsTab: (tab: number) => void
  onRowEditClick: (id: string) => void
  onCreateClick: () => void
  hideDialog: () => void
  dialogVisible: boolean
}

export const useQueryParamDialog: HookType = ({ queryParam = 'id' }) => {
  const history = useHistory()
  const location = useLocation()

  const [detailsTab, setDetailsTab] = useState(0)
  const { dialogVisible, hideDialog: onCloseDialog, onCreateClick, onRowEditClick: onRowClick, entityId } = useFormDialog()

  const onRowEditClick = useCallback(
    (id: string) => {
      setDetailsTab(0)

      const searchParams = new URLSearchParams(location.search)
      searchParams.set(queryParam, id)

      history.push({
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      })
    },
    [location.search, location.pathname, queryParam, history],
  )

  const hideDialog = useCallback(() => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.delete(queryParam)

    history.push({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
    })
    onCloseDialog()
  }, [location.search, location.pathname, queryParam, history, onCloseDialog])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const id = searchParams.get(queryParam)

    if (id) {
      onRowClick(id)
    }
  }, [location.search, queryParam])

  return {
    entityId,
    onRowEditClick,
    onCreateClick,
    hideDialog,
    dialogVisible,
    setDetailsTab,
    detailsTab,
  }
}
